import React from 'react';
//components
import Text from 'components/Text';
//interface
import { SubtitlesProps } from './interfaces';
//styles
import { Container, Item } from './styles';

export const Subtitles: React.FC<SubtitlesProps> = ({ subtitles, orderDetailsPage }) => {
  return (
    <Container orderDetailsPage={orderDetailsPage}>
      {
        subtitles.map(subtitle => (
          <Item key={subtitle.label}>
            <img src={subtitle.img} />
            <Text size={11}>{subtitle.label}</Text>
          </Item>
        ))
      }
    </Container>
  );
};